import { SnowplowService } from 'wanderu-service-analytics';

function fireReferredSignUpEvent({ referralCode }) {
    SnowplowService.fireStructuredEvent({
        category: 'referral_campaign',
        action: 'ref-signup-click',
        label: referralCode,
    });
}

export default {
    fireReferredSignUpEvent,
};
